import { render, staticRenderFns } from "./ResidenceIntroduce.vue?vue&type=template&id=c3a979be"
import script from "./ResidenceIntroduce.vue?vue&type=script&lang=js"
export * from "./ResidenceIntroduce.vue?vue&type=script&lang=js"
import style0 from "./ResidenceIntroduce.vue?vue&type=style&index=0&id=c3a979be&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports